import { fillIconCss, BaseIconProps } from "@components/Icon";
import styled from "@emotion/styled";

import { ReactComponent as InstagramLogoCircle } from "src/assets/icons/instagramLogoCircle.svg";

export default styled(InstagramLogoCircle)<BaseIconProps>`
  ${(props) => fillIconCss(props)}
  .white {
    fill: white;
  }
  stroke: none;
`;
